import { SeatAvailabilityStatus, SeatType } from '@vista-digital/ocapi-types/v1';
import { getSeatsInGroup } from './seat-layout-utils';
export const isSeatSelected = (selectedSeats, seat) => {
    return selectedSeats.some(s => s.id === seat.id);
};
/**
 * Returns true if a seat has an availability status of Available.
 */
export const isSeatAvailable = (data, seat) => {
    const availability = data.seatAvailabilities.find(a => a.seatId === seat.id);
    return (availability === null || availability === void 0 ? void 0 : availability.status) === SeatAvailabilityStatus.Available;
};
export const isSeatAvailableAndNotSelected = (data, selectedSeats, seat) => {
    return isSeatAvailable(data, seat) && !isSeatSelected(selectedSeats, seat);
};
export const isSeatUnavailable = (data, seat) => {
    return !isSeatAvailable(data, seat);
};
/**
 * Returns true if the seat belongs to a sofa that contains
 * any available seats
 */
export const hasAvailableAndNotSelectedSeatsInGroup = (data, selectedSeats, seat) => {
    const seatsInGroup = getSeatsInGroup(data.seatLayout, seat);
    return (!!seatsInGroup && seatsInGroup.some(groupSeat => isSeatAvailableAndNotSelected(data, selectedSeats, groupSeat)));
};
export const hasAvailableAndNotSelectedWheelchairSeatsInGroup = (data, selectedSeats, seat) => {
    const seatsInGroup = getSeatsInGroup(data.seatLayout, seat);
    return (!!seatsInGroup &&
        seatsInGroup.some(groupSeat => {
            return (isSeatAvailableAndNotSelected(data, selectedSeats, groupSeat) && groupSeat.type === SeatType.Wheelchair);
        }));
};
export const isSofaSeatType = (seatType) => {
    switch (seatType) {
        case SeatType.SofaLeft:
        case SeatType.SofaMiddle:
        case SeatType.SofaRight:
            return true;
        default:
            return false;
    }
};
/**
 * Inverts a seat type.
 * Left sofa seats are changed to right and vice versa. Other seat types remain the same.
 */
export const invertSeatType = (type) => {
    switch (type) {
        case SeatType.SofaLeft:
            return SeatType.SofaRight;
        case SeatType.SofaRight:
            return SeatType.SofaLeft;
        default:
            return type;
    }
};
//# sourceMappingURL=seat-utils.js.map